import React from 'react';
import { BundleDetailTemplate } from './BundleDetailTemplate';

export const BundleHiring = () => <BundleDetailTemplate slug="hiring-onboarding" />;
